<template>
  <div class="game-grid-container">
    <Chat />
    <div class="game-word">
      <h6>Mot n°{{ wordNb }}/{{ nbOfWords }}</h6>
      <h1>{{ clientWord }}</h1>
    </div>
    <div class="game-actions">
      <p v-if="isMyTurn">{{ timeLeft }}</p>
      <b-input
        v-if="isMyTurn"
        type="text"
        v-model="word"
        @keypress.native.enter="sendWord"
        maxlength="26"
      />
      <button
        v-if="isMyTurn && currentTurn"
        @click="sendWord"
        :disabled="!wordSanitized"
        class="button is-medium is-link"
      >
        Envoyer
      </button>
      <button
        v-if="isHost"
        @click="passToVote"
        style="margin-top:10px"
        class="button is-medium is-link"
      >
        Passer aux votes
      </button>
    </div>
    <div class="game-turn">
      <h2 v-if="currentTurn != ''">
        Au tour de : {{ playerById[currentTurn].name }}
      </h2>
    </div>
    <div class="game-board">
      <div
        class="player"
        v-for="(player, i) in playerById"
        :key="i"
        :style="`width: calc((100vw - 80px) / ${nbOfPlayers});`"
      >
        <img
          :class="` ${player.isConnected ? '' : 'disconnected'}`"
          :src="avatars[player.avatar]"
          alt="avatar"
          class="avatar"
        />
        <h1
          :class="` ${player.isConnected ? '' : 'disconnected'}`"
          :style="`width: calc((100vw - 80px) / ${nbOfPlayers});`"
        >
          {{ player.name }}
        </h1>
        <b-tooltip
          type="is-dark"
          v-for="(word, i) in player.words"
          :key="i"
          :label="word"
        >
          <h3
            class="word"
            :style="`width: calc((100vw - 80px) / ${nbOfPlayers});`"
          >
            {{ word }}
          </h3>
        </b-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import Chat from "@/components/Chat.vue";

export default {
  name: "Game",
  components: {
    Chat
  },
  data: () => ({
    word: "",
    notifSound: new Audio("/juntos.ogg")
  }),
  methods: {
    sendWord() {
      if (!this.wordSanitized) this.word = " ";
      this.sendMessageToRoom("addWord", this.word);
      this.word = "";
    },
    passToVote() {
      this.sendMessageToRoom("passToVote");
    }
  },
  computed: {
    ...mapState(["avatars"]),
    ...mapState("colyseus", [
      "playerById",
      "currentTurn",
      "wordNb",
      "nbOfWords",
      "timeLeft"
    ]),
    ...mapGetters("colyseus", ["clientWord", "isHost"]),
    isMyTurn() {
      return this.$colyseus.room.sessionId == this.currentTurn;
    },
    wordSanitized() {
      return this.word.length > 0 && this.word.length <= 26;
    },
    nbOfPlayers() {
      return Object.keys(this.playerById).length;
    }
  },
  watch: {
    isMyTurn() {
      if (this.isMyTurn) this.notifSound.play();
    }
  },
  mounted() {
    window.onpopstate = function() {
      history.go(1);
    };
    this.$colyseus.room.onMessage("forcedSwitch", () => {
      this.sendWord();
    });
  }
};
</script>

<style lang="scss" scoped>
.game-grid-container {
  height: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-template-rows: 0.4fr 0.4fr 2.6fr 0.6fr;
  gap: 1px 1px;
  grid-template-areas: ". game-word game-word ." ". game-turn game-turn ." "game-board game-board game-board game-board" ". game-actions game-actions .";
  @media only screen and (max-width: 800px) {
    min-height: 100vh;
  }
}

.game-word {
  grid-area: game-word;
  font-size: 1.5em;
  overflow-y: visible;
}

.game-actions {
  grid-area: game-actions;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
}

.game-turn {
  grid-area: game-turn;
}

.game-board {
  grid-area: game-board;
  height: 100%;
  display: flex;
  justify-content: space-around;
  overflow: auto;
  @media only screen and (max-width: 800px) {
    flex-direction: column;
    height: 70vh;
    overflow-x: scroll;
    width: auto;
  }
}

.player {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 60vh;
  @media only screen and (max-width: 800px) {
    height: auto;
    flex-direction: row;
    justify-content: start;
    flex-wrap: nowrap;
    width: 100%;
  }
}

h3 {
  font-size: 3em;
  @media only screen and (max-width: 800px) {
    margin-left: 10px;
  }
}

.player > h1 {
  font-size: 4vmin !important;
  color: rgb(252, 255, 205) !important;
  font-family: Arial, Helvetica, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media only screen and (max-width: 800px) {
    overflow: visible;
    width: auto !important;
  }
}

.game-turn > h2 {
  font-size: 3vmin !important;
}

.avatar {
  width: 5vw;
  @media only screen and (max-width: 800px) {
    width: 15vw;
    flex-shrink: 0 !important;
  }
}

.word {
  font-size: 3.7vmin;
  font-weight: normal;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  @media only screen and (max-width: 800px) {
    width: 100% !important;
    overflow: visible;
  }
}

h1 {
  @media only screen and (max-width: 800px) {
    font-size: 15vmin !important;
  }
}

h2 {
  @media only screen and (max-width: 800px) {
    font-size: 12vmin !important;
  }
}
</style>
